﻿(function (angular, localStorage) {
  "use strict";

  /*
   * This module extends default localstorage with enhancement to include the expiry date and can set objects
   * ex: localstorage.set(key, value, expireHours)
   * expireHours is an {int} with number of hours to stay alive
   */

  // eslint-disable-next-line no-magic-numbers
  var HOURS_TO_MS_MULTIPLIER = 1000 * 3600;

  angular.module("Toyota.Factories").factory("localstorage", [
    "$window",
    function ($window) {
      function haveLocalStorage() {
        var test = "lctest";
        try {
          localStorage.setItem(test, test);
          localStorage.removeItem(test);
          return true;
        } catch (e) {
          return false;
        }
      }

      return {
        set: function (key, value, expireHours) {
          if (!haveLocalStorage()) {
            return;
          }

          var expiryDate = null;
          var extVal = null;

          if (angular.isNumber(expireHours)) {
            expiryDate = Date.now() + HOURS_TO_MS_MULTIPLIER * expireHours;
          }

          if (typeof value === "object") {
            extVal = angular.extend({ expiry: expiryDate }, value);
          } else {
            extVal = {
              val: value,
              expiry: expiryDate,
            };
          }

          $window.localStorage.setItem(key, JSON.stringify(extVal));
        },
        get: function (key) {
          if (!haveLocalStorage()) {
            return null;
          }

          var val = $window.localStorage.getItem(key);

          if (val) {
            val = JSON.parse(val);
            if (val.expire) {
              var now = Date.now();

              // delete the key if it timed out
              if (val.expire < now) {
                $window.localStorage.removeItem(key);
                return null;
              }

              return val.val;
            }

            return val;
          }

          return null;
        },
        exists: function (key) {
          if (!haveLocalStorage()) {
            return false;
          }

          return $window.localStorage.getItem(key) !== null;
        },
        remove: function (key) {
          if (!haveLocalStorage()) {
            return false;
          }

          var val = $window.localStorage.getItem(key);
          if (val) {
            $window.localStorage.removeItem(key);
            return true;
          }

          return false;
        },
      };
    },
  ]);
})(window.angular, window.localStorage);
